import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import React, { FC } from 'react';

interface IWizardLinkButtonProps {
	onClick: () => void;
	text: string;
}

const WizardLinkButton: FC<IWizardLinkButtonProps> = ({ onClick, text }) => {
	const [loading, setLoading] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setLoading(true);
		onClick();
	}, [onClick]);

	return (
		<LoadingButton
			data-testid="wizard-link-button"
			variant="text"
			onClick={handleClick}
			loading={loading}
		>
			<Typography variant="body1">{text}</Typography>
		</LoadingButton>
	);
};

export default WizardLinkButton;
